import { useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/lib/api-client'
import { useApiContext } from '@/lib/api-context'
import { queryKeys } from '@/lib/query-keys'

export const useCredits = () => {
  const { isReady, isSignedIn } = useApiContext()

  const query = useQuery({
    queryKey: queryKeys.credits,
    queryFn: () => apiClient.getCredits(),
    enabled: isReady && isSignedIn,
    // Credits change frequently (on task completion), so keep staleTime short
    staleTime: 5_000,
    // Always refetch when component mounts to ensure fresh data
    refetchOnMount: 'always',
    // Refetch when window regains focus
    refetchOnWindowFocus: true,
  })

  return {
    data: query.data ?? null,
    loading: query.isLoading,
    error: query.error?.message ?? null,
    refresh: query.refetch,
  }
}

/**
 * Hook to get a function that invalidates the credits cache.
 * Use this after credit-consuming operations (task completion, checkout success, etc.)
 */
export const useInvalidateCredits = () => {
  const queryClient = useQueryClient()
  return () => {
    // Use refetchQueries for immediate refetch (vs invalidateQueries which is lazy)
    void queryClient.refetchQueries({ queryKey: queryKeys.credits })
  }
}
